import { render, staticRenderFns } from "./aprItem.vue?vue&type=template&id=04eb6587&scoped=true&"
import script from "./aprItem.vue?vue&type=script&lang=js&"
export * from "./aprItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb6587",
  null
  
)

export default component.exports